import type { ReactElement } from 'react';
import { useMemo } from 'react';

import gmailIcon from './assets/static/gmailClientIcon.png';
import outlookIcon from './assets/static/outlookClientIcon.png';
import { ClientIcon } from './styles';

interface EmailClient {
    id: string;
    openText: string;
    link: string;
    icon: ReactElement;
}

const getEmailClients = (): EmailClient[] => [
    // Possibly return a link to relevant email client based on email domain?
    {
        id: 'gmail',
        openText: 'Open Gmail',
        link: 'https://mail.google.com',
        icon: <ClientIcon src={gmailIcon} alt="Gmail" />,
    },
    {
        id: 'outlook',
        openText: 'Open Outlook',
        link: 'https://outlook.live.com/mail/0/inbox',
        icon: <ClientIcon src={outlookIcon} alt="Outlook" />,
    },
];

type UseEmailClientsReturn = [EmailClient[], { isLoading: boolean }];

// This is a hook with static isLoading property for future improvements that allow the
// list of email clients to be loaded async
const useEmailClients = (): UseEmailClientsReturn => [useMemo(getEmailClients, []), { isLoading: false }];

export default useEmailClients;
